import { render, staticRenderFns } from "./Marcas.vue?vue&type=template&id=f7b8d5c8&lang=pug"
import script from "./Marcas.vue?vue&type=script&lang=js"
export * from "./Marcas.vue?vue&type=script&lang=js"
import style0 from "./Marcas.vue?vue&type=style&index=0&id=f7b8d5c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports